import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of, empty } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import * as AdminActions from '../admin/admin.action';
import { Constants } from 'src/app/helper/constants';
import { AdminService } from 'src/app/core/services/admin.service';
import { IAdminTemplateResult } from 'src/app/feature/admin/models/admin';
import { IAdminPermissionsResult } from 'src/app/feature/admin/models/permission';
import { ISiteConfigurationResult } from 'src/app/feature/admin/models/site-configuration';

@Injectable()
export class AdminTemplateEffects {
  constructor(private http: HttpClient, private action$: Actions, private adminService: AdminService) { }

  private ApiURL = Constants.PROXY_GROUP;

  GetProxyGroup$: Observable<Action> = createEffect(() =>
    this.action$.pipe(
      ofType(AdminActions.GetAdminDetailsApiAction, AdminActions.CancelGetAdminDetailsApiAction),
      switchMap(action => action.type === '[AdminDetails] Cancel Get AdminDetails' ? empty() :
        this.adminService.getMatrixData().pipe(
          map((data: IAdminTemplateResult) => {
            return AdminActions.SuccessGetAdminDetailsApiAction({ complianceDetails: data });
          }),
          catchError((error: Error) => {
            return of(AdminActions.ErrorGetAdminDetailsApiAction(error));
          })
        )
      )
    )
  );

  GetAdminPermission$: Observable<Action> = createEffect(() =>
    this.action$.pipe(
      ofType(AdminActions.GetAdminPermissionsApiAction, AdminActions.CancelGetAdminPermissionsApiAction),
      switchMap(action => action.type === '[AdminPermissions] Cancel Get AdminPermissions' ? empty() :
        this.adminService.getPermissionData(action.filters).pipe(
          map((data: IAdminPermissionsResult) => {
            return AdminActions.SuccessGetAdminPermissionsApiAction({ permissions: data });
          }),
          catchError((error: Error) => {
            return of(AdminActions.ErrorGetAdminPermissionsApiAction(error));
          })
        )
      )
    )
  );

  GetSuperAdminPermission$: Observable<Action> = createEffect(() =>
    this.action$.pipe(
      ofType(AdminActions.GetSuperAdminPermissionsApiAction, AdminActions.CancelGetSuperAdminPermissionsApiAction),
      switchMap(action => action.type === '[SuperAdminPermissions] Cancel Get SuperAdminPermissions' ? empty() :
        this.adminService.postSuperAdminPermissionData(action.filters).pipe(
          map((data: IAdminPermissionsResult) => {
            return AdminActions.SuccessGetSuperAdminPermissionsApiAction({ permissions: data });
          }),
          catchError((error: Error) => {
            return of(AdminActions.ErrorGetSuperAdminPermissionsApiAction(error));
          })
        )
      )
    )
  );

  GetAdminSiteConfiguration$: Observable<Action> = createEffect(() =>
    this.action$.pipe(
      ofType(AdminActions.GetAdminSiteConfigurationsApiAction, AdminActions.CancelGetAdminSiteConfigurationsApiAction),
      switchMap(action => action.type === '[AdminSiteConfigurations] Cancel Get AdminSiteConfigurations' ? empty() :
        this.adminService.getAllFacilityConfigurations().pipe(
          map((data: ISiteConfigurationResult) => {
            return AdminActions.SuccessGetAdminSiteConfigurationsApiAction({ configurations: data.payload !== undefined ? data.payload : [] });
          }),
          catchError((error: Error) => {
            return of(AdminActions.ErrorGetAdminSiteConfigurationsApiAction(error));
          })
        )
      )
    )
  );
}
